import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Package } from "lucide-react";

const fmtIDR = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");

export const cartKey = (productId, variantId) => `${productId}:${variantId || ""}`;

// Pelanggan/kasir wajib memilih varian sebelum produk masuk keranjang
export function VariantPicker({ product, open, onOpenChange, onPick }) {
  if (!product) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="variant-picker">
        <DialogHeader><DialogTitle>Pilih Varian · {product.name}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {(product.variants || []).map(v => {
            const price = v.daily_price || product.daily_price;
            const out = v.available <= 0;
            return (
              <button key={v.id} type="button" disabled={out} data-testid={`variant-opt-${v.id}`}
                onClick={() => { onPick(product, v); onOpenChange(false); }}
                className={`text-left rounded-md border overflow-hidden transition-colors ${out ? "opacity-40 cursor-not-allowed border-neutral-200 bg-neutral-50" : "border-neutral-200 hover:border-red-600 hover:bg-red-50/30 bg-white"}`}>
                {(v.image_url || product.image_url)
                  ? <img src={v.image_url || product.image_url} alt={v.name} className="w-full h-24 object-cover" />
                  : <div className="w-full h-24 bg-neutral-100 flex items-center justify-center"><Package className="w-7 h-7 text-neutral-300" /></div>}
                <div className="p-2">
                  <div className="font-semibold text-sm text-neutral-900 truncate">{v.name}</div>
                  <div className="text-xs font-mono-tab" style={{ color: "var(--brand-primary)" }}>{fmtIDR(price)}/hari</div>
                  <div className={`text-[11px] mt-0.5 ${out ? "text-red-600 font-semibold" : "text-neutral-500"}`}>{out ? "Habis" : `Ready ${v.available}`}</div>
                </div>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
